import { S3 } from 'aws-sdk';
import { globalEnv } from '../../config/baseConfig';
import * as AWS from 'aws-sdk';

export class uploadS3 {
	private async getS3Bucket(data: any) {
		AWS.config.region = 'us-east-2';
		AWS.config.credentials = new AWS.CognitoIdentityCredentials({
			IdentityPoolId: 'us-east-2:87f779b8-dea9-4bc5-bb1f-50d35ce19edb',
			IdentityId: data.IdentityId,
			Logins: {
				'cognito-identity.amazonaws.com': data.Token
			}
		});
		return new S3({
			region: 'us-east-2'
		});
	}

	async uploadImageS3(
		file: any,
		name: string,
		topicName: string,
		data: any,
		isLowRes = false
	) {
		const s3 = await this.getS3Bucket(data);

		let folderName: string = topicName.replace(/[^a-zA-Z0-9_.]/g, '_');
		const underscoreName: string = String(name).replace(/[^a-zA-Z0-9_.]/g, '_');

		if (isLowRes) folderName = folderName + '/low_res';

		const params = {
			Bucket: globalEnv.BUCKET_NAME,
			Key: `background-images/${folderName.toLowerCase()}/${String(
				underscoreName
			)}`,
			Body: file,
			ACL: 'public-read'
		};
		return new Promise((resolve, reject) => {
			s3.upload(params, (err: any, data: any) => {
				if (err) {
					reject(err.message);
				}
				resolve(data);
			});
		});
	}

	async uploadVideoS3(file: any, name: string, topicName: string, data: any) {
		const s3 = await this.getS3Bucket(data);

		const folderName: string = topicName.replace(/[^a-zA-Z0-9_.]/g, '_');
		const underscoreName: string = String(name).replace(/[^a-zA-Z0-9_.]/g, '_');

		const fileKey = `background-images/${folderName.toLowerCase()}/${String(
			underscoreName
		)}`;

		const params = {
			Bucket: globalEnv.BUCKET_NAME,
			Key: fileKey,
			Body: file,
			ACL: 'public-read'
			// ContentType: 'video/mp4',
		};

		const upload = s3
			.putObject(params)
			.on('httpUploadProgress', (evt) => {
				const qsdf = (evt.loaded * 100) / evt.total;

				console.log('Uploading ' + qsdf + '%');
			})
			.promise();

		return await upload.then((data) => {
			console.log('data', data);
			console.log('res ', data.$response);

			const url = this.getUrlFromBucket(fileKey);
			console.log(url);

			return url;
		});
	}

	getUrlFromBucket = (fileName: string) => {
		return `https://${globalEnv.BUCKET_NAME}.s3.us-east-2.amazonaws.com/${fileName}`;
	};
}
